<template>
  <section class="home">
    <div id="home" style="max-height: 100vh;height: 100vh">
      <NavBar></NavBar>
      <div class="columns is-vcentered" style="max-height: 100vh;height: 100vh">
        <div class="column is-3-desktop left is-offset-1 head">
          <h1 class="title is-size-2-mobile is-1 is-spaced has-text-info">
            {{ $t('title') }}
          </h1>
          <h2 style="margin-bottom: 3em" v-html="$t('slogan')"></h2>
          <a class="button is-info is-rounded is-outlined is-medium" href="#"
             v-scroll-to="'#contact'">{{ $t('home_contact_button') }}</a>
        </div>
        <div class="column is-4-desktop is-offset-2 right" style="margin-top: 2em">
          <img class="head-img" src="hero.png" alt="Hero">
        </div>
      </div>
    </div>
    <!-- <section id="services" class="section is-medium" style="background-color: #fbfbfb;"> -->
    <section id="services" class="section is-medium" style="background-color: #EFF4F7;">
      <div class="container">
        <div class="title-wrapper has-text-centered">
          <h2 class="title is-2">{{ $t('services_title') }}</h2>
          <h3 class="subtitle is-5 is-muted" v-html="$t('services_subtitle')"></h3>
          <div class="divider is-centered"></div>
        </div>
        <div class="content-wrapper">
          <div class="columns">
            <div class="column is-one-third">
              <div class="feature-card is-bordered has-text-centered revealOnScroll delay-1"
                   data-animation="fadeInLeft">
                <div class="card-title">
                  <h4>{{ $t('smm_title') }}</h4>
                </div>
                <div class="card-icon">
                  <img src="../assets/images/mouse-globe.svg">
                </div>
                <div class="card-text">
                  <p>{{ $t('smm_text') }}</p>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="feature-card is-bordered has-text-centered revealOnScroll delay-2"
                   data-animation="fadeInLeft">
                <div class="card-title">
                  <h4>{{ $t('im_title') }}</h4>
                </div>
                <div class="card-icon">
                  <img src="../assets/images/plug-cloud.svg">
                </div>
                <div class="card-text">
                  <p v-html="$t('im_text')"></p>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="feature-card is-bordered has-text-centered revealOnScroll delay-3"
                   data-animation="fadeInLeft">
                <div class="card-title">
                  <h4>{{ $t('website_title') }}</h4>
                </div>
                <div class="card-icon">
                  <img src="../assets/images/laptop-cloud.svg">
                </div>
                <div class="card-text">
                  <p>{{ $t('website_text') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="about" class="section is-medium">
      <div class="container">
        <div class="columns">
          <div class="column is-centered-tablet-portrait">
            <h1 class="title section-title">{{ $t('aboutus_title') }}</h1>
            <h3 class="subtitle is-4 is-muted" v-html="$t('aboutus_subtitle')"></h3>
            <div class="divider"></div>
          </div>
          <div class="column is-8 mt-60">

            <!-- icon block -->
            <article class="media icon-box">
              <figure class="media-left">
                <p class="image">
                  <img src="../assets/images/laptop-globe.svg">
                </p>
              </figure>
              <div class="media-content mt-50">
                <div class="content">
                  <p>
                    <span class="icon-box-title">{{ $t('aboutus_1_title') }}</span>
                    <br>
                    <br>
                    <span class="icon-box-text">
                      {{ $t('aboutus_1_subtitle') }}
                    </span>
                  </p>
                </div>
              </div>
            </article>
            <!-- /icon block -->

            <!-- icon block -->
            <article class="media icon-box">
              <figure class="media-left">
                <p class="image">
                  <img src="../assets/images/doc-sync.svg">
                </p>
              </figure>
              <div class="media-content mt-50">
                <div class="content">
                  <p>
                    <span class="icon-box-title">{{ $t('aboutus_2_title') }}</span>
                    <br>
                    <br>
                    <span class="icon-box-text">
                      {{ $t('aboutus_2_subtitle') }}
                    </span>
                  </p>
                </div>
              </div>
            </article>
            <!-- /icon block -->

            <!-- icon block -->
            <article class="media icon-box">
              <figure class="media-left">
                <p class="image">
                  <img src="../assets/images/mobile-feed.svg">
                </p>
              </figure>
              <div class="media-content mt-50">
                <div class="content">
                  <p>
                    <span class="icon-box-title">{{ $t('aboutus_3_title') }}</span>
                    <br>
                    <br>
                    <span class="icon-box-text">
                      {{ $t('aboutus_3_subtitle') }}
                    </span>
                  </p>
                </div>
              </div>
            </article>
            <!-- /icon block -->

          </div>
        </div>
      </div>
    </section>
    <section id="portfolio" class="section is-medium" style="background-color: hsl(204, 86%, 53%)">
      <div class="container">
        <div class="title-wrapper has-text-centered">
          <h2 class="title is-2 has-text-white is-spaced">{{ $t('portfolio_title') }}</h2>
          <h3 class="subtitle is-5 has-text-white" style="margin-bottom: 3em">
            {{ $t('portfolio_subtitle') }}</h3>
        </div>
        <div class="content-wrapper">
          <div class="columns is-vcentered">
            <div class="column is-4">
              <figure class="testimonial">
                <blockquote style="min-height: 370px">
                  {{ $t('portfolio_customer_1_citation') }}
                </blockquote>
                <div class="author">
                  <img src="../assets/images/faces/anna.png" alt=""/>
                  <h5><a href="https://www.instagram.com/annaweindorfer/" target="_blank">{{ $t('portfolio_customer_1_name') }}</a></h5>
                  <span>{{ $t('portfolio_customer_1_type') }}</span>
                </div>
              </figure>
            </div>
            <div class="column is-4" style="min-height: 250px">
              <figure class="testimonial">
                <blockquote style="min-height: 370px">
                   {{ $t('portfolio_customer_2_citation') }}
                </blockquote>
                <div class="author">
                  <img src="../assets/images/faces/redheads.png" alt=""/>
                  <h5><a href="https://www.instagram.com/best_redheads" target="_blank">{{ $t('portfolio_customer_2_name') }}</a></h5>
                  <span>{{ $t('portfolio_customer_2_type') }}</span>
                </div>
              </figure>
            </div>
            <div class="column is-4">
              <figure class="testimonial">
                <blockquote style="min-height: 370px">
                   {{ $t('portfolio_customer_3_citation') }}
                </blockquote>
                <div class="author">
                  <img src="../assets/images/faces/3.png" alt=""/>
                  <h5>{{ $t('portfolio_customer_3_name') }}</h5>
                  <span>{{ $t('portfolio_customer_3_type') }}</span>
                </div>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="contact" class="section is-medium" style="background-color: #EFF4F7;">
      <div class="container">
        <div class="title-wrapper has-text-centered">
          <h2 class="title is-2 is-spaced">{{ $t('contact_title') }}</h2>
          <h3 class="subtitle is-5 is-muted">{{ $t('contact_subtitle') }}</h3>
          <div class="divider is-centered"></div>
        </div>
        <div class="content-wrapper">
          <div class="columns">
            <div class="column is-half is-offset-one-quarter">
              <div class="box">
                <div class="columns">
                  <div class="column is-half">
                    <div class="field">
                      <label class="label">{{ $t('contact_form_name_label') }}</label>
                      <div class="control">
                        <input class="input" type="text" v-model="name"
                               :placeholder="$t('contact_form_name_placeholder')">
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">{{ $t('contact_form_email_label') }}</label>
                      <div class="control">
                        <input class="input" type="email" v-model="email"
                               :placeholder="$t('contact_form_email_placeholder')">
                      </div>
                    </div>
                  </div>
                  <div class="column is-half">
                    <div class="field">
                      <label class="label">{{ $t('contact_form_company_label') }}</label>
                      <div class="control">
                        <input class="input" type="text" v-model="company"
                              :placeholder="$t('contact_form_company_placeholder')"
                        >
                      </div>
                    </div>
                    <div class="field">
                      <label class="label">{{ $t('contact_form_phone_label') }}</label>
                      <div class="control">
                        <input class="input" type="text" v-model="phone"
                               :placeholder="$t('contact_form_phone_placeholder')">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">{{ $t('contact_form_message_label') }}</label>
                  <div class="control">
                    <textarea class="textarea" v-model="message"
                              :placeholder="$t('contact_form_message_placeholder')">
                    </textarea>
                  </div>
                </div>
                <div class="field is-grouped is-grouped-right">
                  <p class="control" @click="sendMail">
                    <a class="button is-info">
                      {{ $t('contact_form_button_label') }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </section>
</template>

<script>
import axios from 'axios';
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'home',
  components: {
    NavBar,
    Footer,
  },
  data() {
    return {
      name: '',
      email: '',
      company: '',
      phone: '',
      message: '',
    };
  },
  methods: {
    sendMail() {
      axios.post('http://localhost:3200/api/v1/effigon', {
        name: this.name,
        email: this.email,
        company: this.company,
        phone: this.phone,
        message: this.message,
      })
      // eslint-disable-next-line no-unused-vars
        .then((response) => {
          // alert(`SUCCESS${response.data}`);
        });
      this.name = '';
      this.email = '';
      this.company = '';
      this.phone = '';
      this.message = '';
    },
  },
};
</script>

<style>
  body {
    color: gray;
  }

  a {
    text-decoration: none;
  }

  .head {
    margin-top: 5em;
    padding: 3rem 1.5rem;
  }

  .testimonial {
    position: relative;
    overflow: hidden;
    margin: 10px auto;
    min-width: 220px;
    max-width: 310px;
    width: 100%;
    color: #333;
    text-align: left;
    box-shadow: none !important;
  }

  .testimonial img {
    max-width: 100%;
    height: 80px;
    width: 80px;
    border-radius: 50%;
    margin-right: 5px;
    display: block;
    z-index: 1;
    position: absolute;
    right: 60%;
  }

  .testimonial blockquote {
    margin: 0;
    display: block;
    border-radius: 8px;
    position: relative;
    background-color: white;
    padding: 30px 50px 65px 50px;
    font-size: 1.2rem;
    font-weight: 500;
    margin: 0 0 -40px;
    line-height: 1.6em;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);
  }

  .testimonial blockquote:before, blockquote:after {
    font-family: 'Font Awesome 5 Free';
    content: "\f10d";
    position: absolute;
    font-size: 20px;
    opacity: 0.3;
    font-style: normal;
  }

  .testimonial blockquote:before {
    top: 35px;
    left: 20px;
  }

  .testimonial blockquote:after {
    content: "\f10e";
    right: 20px;
    bottom: 35px;
  }

  .testimonial .author {
    margin: 0;
    height: 80px;
    display: block;
    text-align: left;
    color: white;
    padding: 0 35px;
    position: relative;
    z-index: 0;
  }

  .testimonial .author img {
     border: black 1px solid;
  }

  .testimonial h5, span {
    left: 50%;
    position: absolute;
    opacity: 0.8;
    padding: 3px 5px;
  }

  .testimonial h5 {
    text-transform: capitalize;
    bottom: 60%;
    margin: 0;
    font-weight: 600;
    font-size: 1.2rem;
    color: #444F60;
  }

  .testimonial a {
    color: #444F60;
  }

  .testimonial span {
    font-size: 0.8em;
    color: white;
    top: 50%;
  }

  .feature-card {
    width: 300px;
    height: 360px;
    background-color: #fff;
    border-radius: 3px;
    margin: 0 auto;
  }

  .feature-card .card-title h4 {
    font-family: 'Open Sans', sans-serif;
    padding-top: 25px;
    font-size: 1.2rem;
    font-weight: 600;
    color: #444F60;
  }

  .feature-card .card-icon img {
    height: 120px;
    margin-top: 20px;
  }

  .feature-card .card-text {
    padding: 0 40px;
  }

  .feature-card p {
    color: #999;
    font-weight: 500;
  }

  .feature-card .card-action {
    margin-top: 10px;
  }

  .feature-card .is-bordered {
    border: 1px solid #ededed;
  }

  .divider {
    height: 3px;
    border-radius: 50px;
    background: hsl(204, 86%, 53%);
    width: 60px;
  }

  .is-centered {
    margin: 0 auto;
  }

  .content-wrapper {
    padding: 60px 0;
  }

  .media.icon-box {
    border-top: none !important;
  }

  .media.icon-box .media-content .content p span {
    display: block;
  }

  .media.icon-box .media-content .content p .icon-box-title {
    color: #444F60;
    font-size: 1.2rem;
    font-weight: 600;
  }

  .media.icon-box .media-content .content p .icon-box-text {
    color: #999;
    font-size: 1rem;
    font-weight: 500;
  }


</style>
